import type { EmployerSiteName, Environment } from 'src/types';
import { isEnvDev } from 'src/utils/isEnvironment';
import { isInBrowser } from 'src/utils/isInBrowser';

import {
  URL_HIRER_GRAPH,
  URL_HIRER_GRAPH_LOCAL,
  URL_HIRER_GRAPH_STAGING,
} from './api/baseUrl';

const logMetrics = () => {};

const logGraphQLError = (
  graphQlError: any,
  operationName: any,
  operationMetadata: any,
) => {
  // eslint-disable-next-line no-console
  console.log('graphQlError: ', graphQlError);
  // eslint-disable-next-line no-console
  console.log('operationName: ', operationName);
  // eslint-disable-next-line no-console
  console.log('operationMetadata: ', operationMetadata);
};

const logError = (
  networkError: any,
  operationName: any,
  operationMetadata: any,
) => {
  // eslint-disable-next-line no-console
  console.log('networkError: ', networkError);
  // eslint-disable-next-line no-console
  console.log('operationName: ', operationName);
  // eslint-disable-next-line no-console
  console.log('operationMetadata: ', operationMetadata);
};

const getHeaders = (): Headers => new Headers();

const getGraphUri = (environment: Environment, useAuth?: boolean) => {
  if (!isEnvDev(environment)) {
    return URL_HIRER_GRAPH;
  }

  if (useAuth) {
    return URL_HIRER_GRAPH_STAGING;
  }

  return URL_HIRER_GRAPH_LOCAL;
};

export const config = ({
  environment,
  site,
  useAuth,
}: {
  environment: Environment;
  site: EmployerSiteName;
  useAuth?: boolean;
}) => {
  const graphUri = getGraphUri(environment, useAuth);

  return {
    appName: 'hirer-invoices-ui',
    site,
    uri: graphUri,
    logMetrics,
    logGraphQLError,
    logError,
    getHeaders: isInBrowser() ? getHeaders : undefined,
  };
};
